module.exports = __webpack_public_path__ + "themes/fq/sprite/win-sign.json";


//////////////////
// WEBPACK FOOTER
// ./themes/fq/sprite/win-sign.json
// module id = 103
// module chunks = d-game